// extracted by mini-css-extract-plugin
export default {"loadingSpinner-container":"VirtualSources_loadingSpinner-container__U+ylb"};